import { render, staticRenderFns } from "./CommentsItemCard.vue?vue&type=template&id=0e17d077&scoped=true"
import script from "./CommentsItemCard.vue?vue&type=script&lang=js"
export * from "./CommentsItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17d077",
  null
  
)

export default component.exports